import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { GlyphComponent } from './glyph.component';

const routes: Routes = [
  { path: '', component: GlyphComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GlyphRoutingModule { }
